var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Avatar, TableBodyCell } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import { HtmlStringToReact, getSearchEntityAppearance, getSearchEntityIcon, getSearchEntityLink, getSearchHighlightContext, } from 'app/domains/global-search';
import { StyledTypography, TextWrapper, Container } from './styled';
export function TitleCell(props) {
    const { type, entityId, name, highlight } = props, rest = __rest(props, ["type", "entityId", "name", "highlight"]);
    const to = getSearchEntityLink(type, entityId);
    const appearance = getSearchEntityAppearance(type);
    const icon = getSearchEntityIcon(type);
    const { highlightText, showNameOnly } = getSearchHighlightContext(name, highlight);
    return (<TableBodyCell {...rest}>
      <Container>
        <Avatar size="md" appearance={appearance}>
          {icon}
        </Avatar>
        <StyledTypography as={Link} to={to}>
          {showNameOnly ? (<StyledTypography $appearance="300">
              <HtmlStringToReact allowedTags={['mark']} text={highlightText}/>
            </StyledTypography>) : (<TextWrapper>
              <StyledTypography $appearance="300">{name}</StyledTypography>
              <StyledTypography $fontSize="tiny" $appearance="100">
                … <HtmlStringToReact allowedTags={['mark']} text={highlightText}/> …
              </StyledTypography>
            </TextWrapper>)}
        </StyledTypography>
      </Container>
    </TableBodyCell>);
}
